// Config starter code
import { createChatBotMessage } from "react-chatbot-kit";
import ChatbotOptions from "./widgets/ChatbotOptions";

const config = {
    initialMessages: [
        createChatBotMessage("Please enter your email."),
    ],
    botName: "Frilans Finans",
    customStyles: {
        botMessageBox: {
            backgroundColor: "#886cc1",
        },
        chatButton: {
            backgroundColor: "#886cc1",
        },
    },
    widgets: [
        {
            widgetName: "options",
            widgetFunc: (props) => <ChatbotOptions {...props} />,
        },
    ],
};

export default config;
